import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import variableStyles from '../../styles/variables.module.css.js';

const Variant14PathwayIllustration = /*#__PURE__*/ forwardRef(({ color = variableStyles.black, width = '100%' }, ref)=>jsx("svg", {
        width: width,
        viewBox: "0 0 574 1034",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: jsx("path", {
            ref: ref,
            d: "M497.274 70.6982C380.046 190.786 344.216 383.248 410.38 537.468C429.904 582.992 457.245 624.853 477.483 670.065C497.721 715.276 510.856 766.117 499.687 814.367C483.648 883.748 419.315 934.052 350.515 952.414C259.02 976.896 161.314 956.792 70.9805 936.599",
            stroke: color,
            strokeWidth: "140",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
        })
    }));

export { Variant14PathwayIllustration as default };
